/**
 * Havenlytics brand icon (shared across all blocks).
 *
 * This is the same mark the Elementor widgets display in their panel
 * (assets/admin/img/havenlytics-icon.svg), so the Gutenberg inserter shows the
 * identical Havenlytics identity. Passed to registerBlockType( name, { icon } ),
 * which overrides the block.json dashicon fallback in the editor.
 *
 * @package
 * @since   3.5.0
 */

/* eslint-disable react/no-unknown-property */

const HvnlyIcon = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 118 118"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		focusable="false"
	>
		<g clipPath="url(#hvnly_icon_clip)">
			<path
				d="M98.6652 -0.221252H19.5561C8.6288 -0.221252 -0.221191 8.64105 -0.221191 19.5683V98.6652C-0.221191 109.592 8.6288 118.455 19.5561 118.455H98.6652C109.593 118.455 118.455 109.592 118.455 98.6652V19.5683C118.455 8.64105 109.593 -0.221252 98.6652 -0.221252ZM108.56 57.7954C105.979 57.484 103.381 57.3242 100.767 57.316C98.7103 57.316 96.674 57.4144 94.6582 57.611C87.4553 58.2994 80.5596 60.18 74.2048 63.0685C59.295 69.8535 47.3475 82.1943 41.1771 97.7064H19.5561C27.4228 70.6893 48.1588 49.7444 74.2048 41.1402V33.04V20.5394H94.6582V29.3525V37.0962C96.674 36.9405 98.7103 36.8627 100.767 36.8627C103.373 36.8709 105.971 36.9979 108.56 37.2437V57.7954ZM94.6582 97.141H74.2048V71.6727C80.4367 68.3416 87.3569 66.166 94.6582 65.3794V97.141ZM20.9451 20.5148H41.3984V50.7154C33.2859 57.525 26.3411 65.7235 20.9451 75.0037V20.5148Z"
				fill="url(#hvnly_icon_gradient)"
			/>
		</g>
		<defs>
			<linearGradient
				id="hvnly_icon_gradient"
				x1="-0.227339"
				y1="118.458"
				x2="-0.227339"
				y2="-0.221252"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0673077" stopColor="#6C60FE" />
				<stop offset="1" stopColor="#8A7BFF" />
			</linearGradient>
			<clipPath id="hvnly_icon_clip">
				<rect width="118" height="118" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export default HvnlyIcon;
